/**
 * @module components/Feedback/AlertLoading
 * @author Charles Blais <charles.blais@canada.ca>
 */

import React from 'react';
import { Alert } from 'react-bootstrap';

import { useLanguageState } from '../../contexts/language-state-provider';

/**
 * React component
 * ===============
 */
const AlertLoading = () => {
  const [ lang ] = useLanguageState();
  return (
    <Alert>
      <p><strong>{lang.feedback.loading}</strong> {lang.feedback.loadingDetails}</p>
    </Alert>
  );
}

export default AlertLoading;